module.exports = __webpack_public_path__ + "static/media/speaker_microsoft.221f6651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_microsoft.jpg
// module id = 249
// module chunks = 0